import { AuxSelect } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { getLabelForPerformancePeriod } from "../utils";
import { DatapointPerformancePeriodEnum } from "api/ux/src";
import { useWidgetCurrentPeriodOfAnalysis } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
import { setCurrentStatusPeriodOfAnalysis } from "store/current-dashboard";
const performancePeriodSelectOptions = (sectionId, widgetId) => [
    {
        values: [
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.OneQuarter}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.OneQuarter),
                value: DatapointPerformancePeriodEnum.OneQuarter
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.SixMonths}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.SixMonths),
                value: DatapointPerformancePeriodEnum.SixMonths
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.OneYear}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.OneYear),
                value: DatapointPerformancePeriodEnum.OneYear
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.Ytd}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.Ytd),
                value: DatapointPerformancePeriodEnum.Ytd
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.ThreeYears}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.ThreeYears),
                value: DatapointPerformancePeriodEnum.ThreeYears
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.FiveYears}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.FiveYears),
                value: DatapointPerformancePeriodEnum.FiveYears
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.TenYears}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.TenYears),
                value: DatapointPerformancePeriodEnum.TenYears
            },
            {
                auxId: `${sectionId}-${widgetId}-${DatapointPerformancePeriodEnum.Itd}`,
                displayValue: getLabelForPerformancePeriod(DatapointPerformancePeriodEnum.Itd),
                value: DatapointPerformancePeriodEnum.Itd
            }
        ]
    }
];
export const InsSettingsPeriodOfAnalysis = ({ sectionId, widgetId }) => {
    const dispatch = useDispatch();
    const currentPeriodOfAnalysis = useWidgetCurrentPeriodOfAnalysis(sectionId, widgetId);
    const onPeriodOfAnalysisSelected = (event) => {
        const value = event.detail.value;
        dispatch(setCurrentStatusPeriodOfAnalysis({
            periodOfAnalysis: value?.value,
            sectionId,
            widgetId
        }));
    };
    const data = performancePeriodSelectOptions(sectionId, widgetId);
    data[0].values = data[0].values.map((o) => ({ ...o, isSelected: currentPeriodOfAnalysis === o.value }));
    return React.createElement(AuxSelect, { label: language.en.skeleton.settingsMenu.periodOfAnalysis.periodOfAnalysis, size: "regular", type: "simple", data: data, onSelectionChanged: onPeriodOfAnalysisSelected });
};
